module.exports = __webpack_public_path__ + "img/abgc7.0471eda1.jpg";